import angular from 'angular';
import nzbnPartyTypeFields from './nzbnPartyTypeFields';
import './style.scss';

export default angular
  .module('components.nzbnPartyTypeFields', [])
  .component('nzbnPartyTypeFields', nzbnPartyTypeFields).name;
